import { ChangeDetectionStrategy, Component, OnInit, inject, input } from '@angular/core';
import { StudentDataService } from 'src/app/core/services/student-data.service';
import { DecimalPipe } from '@angular/common';

@Component({
    selector: 'total-points',
    templateUrl: './total-points.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [DecimalPipe]
})
export class TotalPointsComponent implements OnInit {
  readonly totalPoints = input<number>();

  private readonly studentDataService = inject(StudentDataService);

  showTotalPointsContainer: boolean = false;
  totalPointsBackgroundColor: string = '';
  totalPointsBorderColor: string = '';

  ngOnInit(): void {
    let inIntervention: boolean = this.studentDataService.isIntervention();
    this.showTotalPointsContainer = inIntervention;

    if (inIntervention) {
      this.totalPointsBackgroundColor = this.studentDataService.getTaskBarTotalPointsBackgroundColor();
      this.totalPointsBorderColor = this.studentDataService.getTaskBarTotalPointsBorderColor();
    }
  }
}
